import { useCallback, useContext } from 'react';

import FormContext from 'ia-react-core/~/components/form/FormContext';
import ScopeContext from 'ia-react-core/~/components/redux/_ScopeContext/ScopeContext';
import { BehaviorInstance } from 'ia-react-core/~/services/behavior/_Behavior';

export interface UseResolveBehaviorOptions {
  defaultInput?: string;
  defaultScope?: string;
}

const useResolveBehavior = (options?: UseResolveBehaviorOptions) => {
  const { scope } = useContext(ScopeContext);
  const { valuesDst, ancestorFormReducerScope, formReducerKey } = useContext(FormContext);

  const resolve = useCallback((behavior: BehaviorInstance<any>, state: any) => {
    const defaultOptions = options?.defaultInput ? { defaultInput: options?.defaultInput } : {};
    const behaviorResult = behavior.resolve({
      state,
      scope,
      formReducerKey,
      valuesDst,
      ancestorFormReducerScope,
      defaultScope: options?.defaultScope || ancestorFormReducerScope ? 'values' : 'state',
      ...defaultOptions,
    });

    return behaviorResult;
  }, [ancestorFormReducerScope, formReducerKey, options?.defaultInput, options?.defaultScope, scope, valuesDst]);

  return resolve;
};

export default useResolveBehavior;
